<div class="pt-4">
  <app-input-multi-atom
    [type]="'checkbox'"
    [value]="forceType(value)"
    [label]="title"
    (valueEmitter)="onValueChange(forceType($event))"
  ></app-input-multi-atom>
</div>
